import { ANALYSIS_CLASSIFICATION } from "../../consts";

const RL_AUXILIARY_ANALYSIS_LIMITS = {
  GOODWARE: 0,
  UNKNOWN: 300,
  SUSPICIOUS: 1000
};

const getRlAuxiliaryAnalysisClassification = (score: number) => {
  if (score < RL_AUXILIARY_ANALYSIS_LIMITS.GOODWARE) {
    return ANALYSIS_CLASSIFICATION.GOODWARE;
  }
  if (score < RL_AUXILIARY_ANALYSIS_LIMITS.UNKNOWN) {
    return ANALYSIS_CLASSIFICATION.UNKNOWN;
  }
  if (score < RL_AUXILIARY_ANALYSIS_LIMITS.SUSPICIOUS) {
    return ANALYSIS_CLASSIFICATION.SUSPICIOUS;
  }
  return ANALYSIS_CLASSIFICATION.MALICIOUS;
};

export { getRlAuxiliaryAnalysisClassification };
